import type { ReactElement } from 'react';
import '@styles/components/_fatal-fallback.scss';

interface FatalFallbackProps {
  message?: string;
}

const DEFAULT_MESSAGE =
  'Something went wrong. Please refresh the page or contact support if the issue persists.';

export const FatalFallback = ({ message = DEFAULT_MESSAGE }: FatalFallbackProps): ReactElement => (
  <div className="fatal-fallback" role="alert" aria-live="assertive">
    <div className="fatal-fallback__container">
      <div className="fatal-fallback__icon" aria-hidden="true">
        ✕
      </div>
      <h1 className="fatal-fallback__title">Unable to Load Application</h1>
      <p className="fatal-fallback__message">{message}</p>
      <button
        className="fatal-fallback__action"
        type="button"
        onClick={(): void => window.location.reload()}
      >
        Refresh Page
      </button>
    </div>
  </div>
);
